<template>
  <div v-if="visible" class="loading-bar"></div>
   <div v-if="visible" class="page-blocker">
    <div class="spinner"></div>
  </div>
</template>

<script setup>
defineProps({
  visible: Boolean
});
</script>

<style scoped>
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 3px;

  z-index: 9999;
  overflow: hidden;
}

.loading-bar::before {
  content: '';

  position: absolute;
  left: -40%;
  width: 40%;
  height: 100%;

  background: #006eff;

  animation: loading 1.2s infinite;
}

.page-blocker {
  position: fixed;
  inset: 0;

  background: rgba(255,255,255,0.2);

  z-index: 99999;

  cursor: wait;
}

.spinner {
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
}

@keyframes loading {
  from {
    left: -40%;
  }

  to {
    left: 100%;
  }
}
</style>